export default {
  careerPage: {
    title: "Carrière",
    subtitle: "Mon Expérience",
    catchphrase:
      "Je suis passionné par l'apprentissage continu et la résolution de problèmes techniques complexes, et je suis toujours à la recherche de nouveaux défis, de nouvelles rencontres et de partage.",
    jobs: {
      informationSystemControl2024: {
        jobTitle: "Contrôle du Système d'Information - Service Pharmacie-Stérilisation",
        location: "CHRU de Strasbourg - Hôpitaux Universitaires de Strasbourg",
        dates: "2024",
        duration: "Aujourd'hui",
        description: [
          "Requête, extraction, traitement de données.",
          "Alimentation de tableau de bord et suivi.",
          "Suivi, mise à jour, enregistrement de données relatives aux marchés et produits du secteur 'Pharmacie'.",
        ],
      },
      fullStackMERN2024: {
        jobTitle: "Développeur Full-Stack - MERN",
        location: "Formation Indépendante",
        dates: "2024-2024",
        duration: "7 mois",
        description: [
          "Développeur Full Stack à travers la stack MERN (MongoDB, Express.js, React, Node.js), avec une expérience approfondie en Front-end React JS.",
        ],
      },
      frontendReactAzeon2023: {
        jobTitle: "Développeur Front-end - JavaScript/React",
        location: "Agence Azeon",
        dates: "2023-2023",
        duration: "2 mois",
        description: [
          "Proposer un MVP du cœur de la page 'offre d'emploi' pour son client avec les technologies REACT JS et REDUX.",
          "Un nouveau Full Responsive Web Design, comprenant les fonctionnalités : de recherches avancées, de consultation et de candidature aux offres, de souscription à la newsletter ainsi que la mise en avant des 'offres urgentes'",
        ],
      },
      frontendReactOpenclassrooms2022: {
        jobTitle: "Développeur Front-end - JavaScript/React",
        location: "Openclassrooms",
        dates: "2022-2023",
        duration: "1 an",
        description: [
          "Développer le Front-end d'applications (SaaS / Web) et d'interfaces utilisateur (SPA / Web)",
        ],
      },
      userSupportTechnician2013: {
        jobTitle: "Technicien Support Utilisateurs - Service Informatique",
        location: "Urssaf Alsace",
        dates: "2013-2021",
        duration: "8 ans",
        description: [
          "Identifier avec son interlocuteur les besoins et co-construire une solution ou une réponse appropriée.",
          "Se positionner dans une relation de service auprès des utilisateurs.",
          "Assurer un rôle de support et d'assistance polyvalente auprès des utilisateurs sur leurs postes de travail.",
          "Poursuite des travaux nationaux sur l’AED.",
          "Assistance et formation des utilisateurs aux outils de GED.",
        ],
      },
      expertReferent2008: {
        jobTitle: "Expert Référent - Flux Entrant Non Dématérialisé et Image",
        location: "Urssaf Alsace",
        dates: "2008-2013",
        duration: "5 ans",
        description: [
          "Pilote Adjoint du projet de déploiement et d’administration d’une nouvelle chaîne de production pour la dématérialisation des documents.",
          "Participation aux groupes de travail nationaux sur l’archivage électronique des document (AED) et rédaction des procédures.",
          "Animation d’équipe, accompagnement au changement et formation des agents sur les nouveaux outils et processus.",
          "Administration fonctionnelle et technique des outils de GED.",
        ],
      },
      advisorServiceOffers2005: {
        jobTitle: "Conseiller - Offres de Services",
        location: "Urssaf Alsace",
        dates: "2005-2008",
        duration: "3 ans",
        description: [
          "Promouvoir et suivre les services dématérialisés proposés par le réseau de recouvrement.",
          "Information et accompagnement des clients et partenaires.",
        ],
      },
      accountManager2001: {
        jobTitle: "Gestionnaire de Comptes - Recouvrement Amiable et Forcé",
        location: "Urssaf Alsace",
        dates: "2001-2005",
        duration: "4 ans",
        description: [
          "Gérer un portefeuille de comptes clients en matière de contentieux et gérer les relations avec les partenaires.",
          "Information et accompagnement des clients concernant leurs obligations et leurs droits.",
        ],
      },
    },
  },
}
